import React from "react";
import { useDisclosure, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { SetOrderRequestListingColumnsConfigDialog } from "./SetOrderRequestListingColumnsConfigDialog";

export interface SetOrderRequestListingColumnsConfigButtonProps {
    pageSize: number;
    setPageSize(pageSize: number): void;
}
export const SetOrderRequestListingColumnsConfigButton: React.VFC<SetOrderRequestListingColumnsConfigButtonProps> = (
    props: SetOrderRequestListingColumnsConfigButtonProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();
    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdRead]}>
            <CommandBarButton icon={"Settings"} onClick={onOpen} text={`Config`} />
            {isOpen && (
                <SetOrderRequestListingColumnsConfigDialog
                    key={String(isOpen)}
                    isOpen={isOpen}
                    onClose={onClose}
                    pageSize={props.pageSize}
                    setPageSize={props.setPageSize}
                />
            )}
        </AuthorizationWrapper>
    );
};
